import { createStyles, rem } from '@mantine/styles';
var useStyles = createStyles(function (_theme, _ref) {
  var swatchesPerRow = _ref.swatchesPerRow;
  return {
    swatch: {
      width: "calc(".concat(100 / swatchesPerRow, "% - ").concat(rem(4), ")"),
      height: 0,
      paddingBottom: "calc(".concat(100 / swatchesPerRow, "% - ").concat(rem(4), ")"),
      margin: rem(2),
      boxSizing: "content-box"
    },
    swatches: {
      boxSizing: "border-box",
      marginLeft: rem(-2),
      marginRight: rem(-2),
      display: "flex",
      flexWrap: "wrap"
    }
  };
});
export default useStyles;